/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserVehicleAccessSchema } from '../models/UserVehicleAccessSchema';
import type { UserVehicleAccessRemoveSchema } from '../models/UserVehicleAccessRemoveSchema';
import type { UserVehicleAccessUpdateSchema } from '../models/UserVehicleAccessUpdateSchema';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class UserVehicleAccessService {
  /**
   * Get all vehicle access entries for a user
   * @param userId
   * @returns UserVehicleAccessSchema Successful Response
   * @throws ApiError
   */
  public static getUserVehicleAccess(
    userId: number
  ): CancelablePromise<Array<UserVehicleAccessSchema>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/v1/users/{user_id}/vehicles/',
      path: {
        user_id: userId,
      },
    });
  }

  /**
   * Update vehicle access list for a user (replaces all)
   * @param userId
   * @param requestBody
   * @returns UserVehicleAccessSchema Updated list
   * @throws ApiError
   */
  public static updateUserVehicleAccess(
    userId: number,
    requestBody: UserVehicleAccessUpdateSchema
  ): CancelablePromise<Array<UserVehicleAccessSchema>> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/v1/users/{user_id}/vehicles/',
      path: {
        user_id: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }

  /**
   * Remove selected vehicles from user access
   * @param userId
   * @param requestBody
   * @returns any Success status
   * @throws ApiError
   */
  public static removeUserVehicleAccess(
    userId: number,
    requestBody: UserVehicleAccessRemoveSchema
  ): CancelablePromise<any> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/v1/users/{user_id}/vehicles/',
      path: {
        user_id: userId,
      },
      body: requestBody,
      mediaType: 'application/json',
    });
  }
}
